import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faLockOpen,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

import { useManagePostRequest } from "../../../../../../hooks/useManagePostRequest/useManagePostRequest";
import { useManageGetRequest } from "../../../../../../hooks/useManageGetRequest/useManageGetRequest";

import FormSelect from "../../../../../../components/atoms/Select";
import FormDatePicker from "../../../../../../components/atoms/DatePicker";
import { toast } from "react-toastify";
import PageTable from "../../../../../../components/pageComponents/PageTable";
import useDidMountEffect from "../../../../../../hooks/useDidMountEffect/useDidMountEffect";
import {
  handleFind,
  jsonNoEstaVacio,
  updateFiltersWithExtraData,
} from "../../../../../../helper/utils";
import PageWrapper from "../../../../../../components/pageComponents/PageWrapper";
import Select from "react-select";
import {
  cuadroRequerimientosGetCursosByIdCuadroSede,
  cuadroRequerimientosRegistrarPendienteAsignacionAPI,
  cuadroRequerimientosBloquearEmpleadoAPI,
  cuadroRequerimientosDesbloquearEmpleadoAPI,
  cuadroRequerimientosGetPendientesCuadroSedeId,
} from "../../../../../../consumers/backendApisUrls";
import {TooltipWrapper} from "../../../../styledComponents/styledComponents";
import ModalEnabled from "../../../../../../components/modalComponents/ModalEnabled";
import AsignarPendienteToVacante from "./modales/AsignarPendienteToVacante";
import {
    TIPO_ASIGNACION_ASIGNAR_VACANTE, TIPO_ASIGNACION_EXCEDENTE,
    TIPO_ASIGNACION_TEMPORAL,
    TIPO_ASIGNACION_VOLANTE
} from "../../../../constants/CR_Constants";

const INIT_KEYS = {
  IdsCargos: "IdsCargos",
  IdsTipoContrato: "IdsTipoContrato",
  IdsGradoDesarrollo: "IdsGradoDesarrollo",
  IdsEtiqueta: "IdsEtiqueta",
};

const ALL_TIPO_OPTIONS = [
  { value: TIPO_ASIGNACION_EXCEDENTE, label: TIPO_ASIGNACION_EXCEDENTE },
  { value: TIPO_ASIGNACION_VOLANTE, label: TIPO_ASIGNACION_VOLANTE},
  { value: TIPO_ASIGNACION_TEMPORAL, label: TIPO_ASIGNACION_TEMPORAL },
  { value: TIPO_ASIGNACION_ASIGNAR_VACANTE, label: TIPO_ASIGNACION_ASIGNAR_VACANTE },
];

const ETIQUETA_COLORS = {
  "Consol.": { bg: "#e8f5e9", color: "#2e7d32" },
  Consolidado: { bg: "#e8f5e9", color: "#2e7d32" },
  Logrado: { bg: "#e3f2fd", color: "#1565c0" },
  "En prog.": { bg: "#fff8e1", color: "#f57f17" },
  "En Proceso": { bg: "#fff8e1", color: "#f57f17" },
  Inicio: { bg: "#fce4ec", color: "#c62828" },
};

const formatFecha = (fechaStr) => {
  if (!fechaStr) return "—";
  const date = new Date(fechaStr);
  if (isNaN(date)) return "—";
  return date.toLocaleDateString("es-PE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const iconBtnStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0",
  backgroundColor: "transparent",
  border: "none",
  color: "#000",
  cursor: "pointer",
  fontSize: "14px",
};

const EtiquetaBadge = styled.span`
  background-color: ${({ bg }) => bg || "#f3e5f5"};
  color: ${({ color }) => color || "#6a1b9a"};
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`;

const DesempenoValue = styled.span`
  font-weight: 700;
  font-size: 13px;
  color: ${({ value }) =>
    value >= 90 ? "#2e7d32" : value >= 75 ? "#1565c0" : "#f57f17"};
`;

const TrasladoBadge = styled.span`
  display: inline-block;
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 10px;
  background-color: #e3f2fd;
  color: #1565c0;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;
const ModalBox = styled.div`
  background: #fff;
  border-radius: 10px;
  width: 520px;
  max-width: 95vw;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  overflow: hidden;
`;
const ModalHeader = styled.div`
  background-color: #0064a7;
  width: 100%;
  height: 40px;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  gap: 15px;
  p {
    margin: 0;
    padding: 0 35px;
    font-size: 16px;
    font-weight: 600;
  }
`;

const ModalBody = styled.div`
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1;
`;
const ModalFooter = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const tableStyles = `
  .listar-tbody,
  .listar-tbody tr,
  .listar-tbody td {
    overflow: visible !important;
  }
  .fecha-ingreso-header .description {
  height: auto !important;
  padding-top: 0 !important;
  margin: 0 !important;
  font-size: 12px !important;
  line-height: normal !important;
  transform: translateY(-2px);
  }

  .fecha-ingreso-header .modal-Filtros span.col-form-label {
  font-family: GothamLight !important;
  font-weight: 400 !important;
  }

  .fecha-ingreso-header .modal-Filtros input[type="date"] {
  font-family: GothamLight !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  }
  .modal-Filtros {
    position: fixed !important;
    top: auto !important;
    left: auto !important;
    z-index: 99999 !important;
    background: white !important;
    min-width: 200px !important;
    max-height: 300px !important;
    overflow-y: auto !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
    border-radius: 8px !important;
  }
`;

export default function CuadroRequerimientosListarPendientesTab({
  idCuadroSede,
}) {
  const [executeManagePost] = useManagePostRequest();
  const [executeManageGet] = useManageGetRequest();

  const [formValues, setFormValues] = useState({
    Items: [],
    ExtraData: {},
    filters: [],
    selectedFilters: {},
  });
  const [allFilters, setAllFilters] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [isLoading, setIsLoading] = useState(true);
  const [fechaIngresoInicio, setFechaIngresoInicio] = useState(null);
  const [fechaIngresoFin, setFechaIngresoFin] = useState(null);

  const [tipoValues, setTipoValues] = useState({});

  const [showModalCursos, setShowModalCursos] = useState(false);
  const [cursos, setCursos] = useState([]);
  const [loadingCursos, setLoadingCursos] = useState(false);
  const [cursoSeleccionado, setCursoSeleccionado] = useState(null);
  const [rowEnProceso, setRowEnProceso] = useState(null);
    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});


  const manageSearch = async () => {
    setIsLoading(true);
    const api = cuadroRequerimientosGetPendientesCuadroSedeId();
    const payload = getPayload();
    await executeManagePost(api, payload, successManageSearchCallback);
    setIsLoading(false);
  };

  const getPayload = () => ({
    IdCuadroSede: idCuadroSede,
    Criteria: searchCriteria,
    Page: paginator.CurrentPage,
    ...formValues.selectedFilters,
  });

  const successManageSearchCallback = ({ data }) => {
    const {
      Items,
      ExtraData,
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
    } = data;
    setFormValues((lastData) => ({ ...lastData, Items, ExtraData }));
    setPaginator({
      TotalItems,
      FirsItemPage,
      LastItemPage,
      TotalPages,
      CurrentPage,
    });

  };

  const buildAllFiltersAndUpdateFilters = (items, extraData) => {
    setAllFilters((prev) => {
      const cargoMap = Object.fromEntries(
        (prev.find((f) => f.key === INIT_KEYS.IdsCargos)?.value ?? []).map(
          (o) => [o.Value, o.Text],
        ),
      );
      const tipoMap = Object.fromEntries(
        (
          prev.find((f) => f.key === INIT_KEYS.IdsTipoContrato)?.value ?? []
        ).map((o) => [o.Value, o.Text]),
      );
      const gradoMap = Object.fromEntries(
        (
          prev.find((f) => f.key === INIT_KEYS.IdsGradoDesarrollo)?.value ?? []
        ).map((o) => [o.Value, o.Text]),
      );
      const etiquetaMap = Object.fromEntries(
        (prev.find((f) => f.key === INIT_KEYS.IdsEtiqueta)?.value ?? []).map(
          (o) => [o.Value, o.Text],
        ),
      );

      items.forEach((item) => {
        if (item.IdCargo && item.Cargo) cargoMap[item.IdCargo] = item.Cargo;
        if (item.IdTipoContrato && item.TipoContrato)
          tipoMap[item.IdTipoContrato] = item.TipoContrato;
        if (item.IdGradoDesarrollo && item.GradoDesarrollo)
          gradoMap[item.IdGradoDesarrollo] = item.GradoDesarrollo;
        if (item.Etiqueta) etiquetaMap[item.Etiqueta] = item.Etiqueta;
      });

      const newAllFilters = [
        {
          key: INIT_KEYS.IdsCargos,
          value: Object.entries(cargoMap).map(([v, t]) => ({
            Value: Number(v),
            Text: t,
          })),
        },
        {
          key: INIT_KEYS.IdsTipoContrato,
          value: Object.entries(tipoMap).map(([v, t]) => ({
            Value: Number(v),
            Text: t,
          })),
        },
        {
          key: INIT_KEYS.IdsGradoDesarrollo,
          value: Object.entries(gradoMap).map(([v, t]) => ({
            Value: Number(v),
            Text: t,
          })),
        },
        {
          key: INIT_KEYS.IdsEtiqueta,
          value: Object.entries(etiquetaMap).map(([v, t]) => ({
            Value: v,
            Text: t,
          })),
        },
      ];

      if (jsonNoEstaVacio(extraData)) {
        updateFiltersWithExtraData(
          newAllFilters,
          extraData,
          handleUpdatedFilters,
        );
      }

      return newAllFilters;
    });
  };

  const handleUpdatedFilters = (res) =>
    setFormValues((lastData) => ({ ...lastData, filters: res }));

  const handleFilterSelected = (res, key) =>
    setFormValues((lastData) => ({
      ...lastData,
      selectedFilters: { ...lastData.selectedFilters, [key]: res },
    }));

  const searchByFechas = () => {
    if (!(fechaIngresoInicio && fechaIngresoFin)) {
      toast.warn("Debe ingresar ambas fechas");
      return;
    }

    setFormValues((lastData) => ({
      ...lastData,
      selectedFilters: {
        ...lastData.selectedFilters,
        FechaInicio: fechaIngresoInicio,
        FechaFin: fechaIngresoFin,
      },
    }));
  };

  const handleCleanSearch = () => {
    setFormValues((prev) => ({ ...prev, selectedFilters: {} }));
    setSearchCriteria("");
    setFechaIngresoInicio(null);
    setFechaIngresoFin(null);
  };

  const init = async () => {
    setIsLoading(true);
    try {
      await manageSearch();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, [idCuadroSede]);

  useDidMountEffect(() => {
    buildAllFiltersAndUpdateFilters(formValues.Items, formValues.ExtraData);
  }, [formValues.ExtraData]);

  useDidMountEffect(() => {
    manageSearch();
  }, [paginator.CurrentPage, formValues.selectedFilters]);

  const handleTipoChange = async (rowId, value, row) => {
    if (!value) return;

    setTipoValues((prev) => ({ ...prev, [rowId]: value }));

    if (value === "Excedente") {
      const payload = {
        IdCuadroSede: idCuadroSede,
        IdEmpleado: row.IdEmpleado,
        TipoAsignacion: "Excedente",
        Especialidad: "",
      };
      try {
        await executeManagePost(
          cuadroRequerimientosRegistrarPendienteAsignacionAPI(),
          payload,
          () => {
            manageSearch();
          },
        );
      } catch (error) {
        console.error("Error al registrar Excedente:", error);
        setTipoValues((prev) => ({ ...prev, [rowId]: "" }));
      }
    } else if (value === TIPO_ASIGNACION_TEMPORAL) {
        const payload = {
            IdCuadroSede: idCuadroSede,
            IdEmpleado: row.IdEmpleado,
            TipoAsignacion: TIPO_ASIGNACION_TEMPORAL,
            Especialidad: "",
        };
        try {
            await executeManagePost(
                cuadroRequerimientosRegistrarPendienteAsignacionAPI(),
                payload,
                () => {
                    manageSearch();
                },
            );
        } catch (error) {
            console.error("Error al registrar Temporal:", error);
            setTipoValues((prev) => ({ ...prev, [rowId]: "" }));
        }
    }
    else if (value === TIPO_ASIGNACION_VOLANTE) {
      setRowEnProceso(row);
      setCursoSeleccionado(null);
      setShowModalCursos(true);
      setLoadingCursos(true);
      await executeManageGet(
        cuadroRequerimientosGetCursosByIdCuadroSede(idCuadroSede),
        ({ data }) => setCursos(Array.isArray(data) ? data : []),
        false,
      );
      console.log(cursos);
      setLoadingCursos(false);
    } else if (value === TIPO_ASIGNACION_ASIGNAR_VACANTE) {
        setModalEnabled({
            isEnable: true,
            component: AsignarPendienteToVacante,
            data: { idEmpleado : row.IdEmpleado, idCuadroSede: idCuadroSede, setTipoValues: setTipoValues}
        })
    }

  };
  const handleCerrarModal = () => {
    if (rowEnProceso) {
      const rowId = `${rowEnProceso.IdCuadroSede}-${rowEnProceso.IdAsignacion}-${rowEnProceso.IdEmpleado}`;
      setTipoValues((prev) => ({ ...prev, [rowId]: "" })); // ← vuelve a "Seleccionar"
    }
    setShowModalCursos(false);
    setCursoSeleccionado(null);
    setRowEnProceso(null);
    setCursos([]);
  };
  const handleAsignarCurso = async (e) => {
    e.preventDefault();
    try {
      await executeManagePost(
        cuadroRequerimientosRegistrarPendienteAsignacionAPI(),
        getPayloadAsignacion(),
        () => {
          handleCerrarModal();
          manageSearch();
        },
      );
    } catch (error) {
      console.error("Error al asignar curso:", error);
    }
  };

  const getPayloadAsignacion = () => {
    const rowId = `${rowEnProceso?.IdCuadroSede}-${rowEnProceso?.IdAsignacion}-${rowEnProceso?.IdEmpleado}`;
    return {
      IdCuadroSede: idCuadroSede,
      IdEmpleado: rowEnProceso?.IdEmpleado,
      TipoAsignacion: tipoValues[rowId] ?? TIPO_ASIGNACION_VOLANTE,
      Especialidad: cursoSeleccionado,
    };
  };

  const handleBloquear = async (row) => {
    try {
      await executeManagePost(
        cuadroRequerimientosBloquearEmpleadoAPI(),
        { IdCuadroSede: idCuadroSede, IdEmpleado: row.IdEmpleado },
        () => {
          manageSearch();
        },
      );
    } catch (error) {
      console.error("Error al bloquear empleado:", error);
    }
  };

  const handleDesbloquear = async (row) => {
    try {
      await executeManagePost(
        cuadroRequerimientosDesbloquearEmpleadoAPI(),
        { IdCuadroSede: idCuadroSede, IdEmpleado: row.IdEmpleado },
        () => {
          manageSearch();
        },
      );
    } catch (error) {
      console.error("Error al desbloquear empleado:", error);
    }
  };

  const HEADERS = [
    { col: "col-sm-1", label: "Info" },
    { col: "col-sm-1", label: "Código de Vacante" },
    { col: "col-sm-1", label: "Tipo" },
    { col: "col-sm-2", label: "Profesor / Asistente" },
    {
      col: "col-sm-2",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(formValues.filters, INIT_KEYS.IdsCargos)}
            description="Cargo"
            selectedOptions={
              formValues.selectedFilters?.[INIT_KEYS.IdsCargos] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, INIT_KEYS.IdsCargos)
            }
          />
        </div>
      ),
    },
    {
      col: "col-sm-2",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(formValues.filters, INIT_KEYS.IdsTipoContrato)}
            description="Tipo de Contrato"
            selectedOptions={
              formValues.selectedFilters?.[INIT_KEYS.IdsTipoContrato] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, INIT_KEYS.IdsTipoContrato)
            }
          />
        </div>
      ),
    },
    {
      col: "col-sm-1",
      label: (
          <div className="d-flex justify-content-center fecha-ingreso-header">
            <FormDatePicker
                description="Fecha Ingreso"
                fechaInicio={fechaIngresoInicio}
                fechaFin={fechaIngresoFin}
                setFechaInicio={setFechaIngresoInicio}
                setFechaFin={setFechaIngresoFin}
                searchByFechas={searchByFechas}
            />
          </div>
      ),
    },
    {
      col: "col-sm-1",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(
              formValues.filters,
              INIT_KEYS.IdsGradoDesarrollo,
            )}
            description="Grado"
            selectedOptions={
              formValues.selectedFilters?.[INIT_KEYS.IdsGradoDesarrollo] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, INIT_KEYS.IdsGradoDesarrollo)
            }
          />
        </div>
      ),
    },
    { col: "col-sm-1", label: "R. Porcent." },
    {
      col: "col-sm-1",
      label: (
        <div className="d-flex justify-content-center">
          <FormSelect
            options={handleFind(formValues.filters, INIT_KEYS.IdsEtiqueta)}
            description="R. Final"
            selectedOptions={
              formValues.selectedFilters?.[INIT_KEYS.IdsEtiqueta] ?? []
            }
            setSelectedOptions={(res) =>
              handleFilterSelected(res, INIT_KEYS.IdsEtiqueta)
            }
          />
        </div>
      ),
    },
    { col: "col-sm-1", label: "Año de Evaluación" },
    { col: "col-sm-1", label: "Acciones" },
  ];

  return (
    <>
      <style>{tableStyles}</style>




      <PageWrapper isLoading={isLoading}>

          <ModalEnabled
              modalEnabled={modalEnabled}
              setModalEnabled={setModalEnabled}
              refreshPage={manageSearch}
          />



        {showModalCursos && (
          <ModalOverlay onClick={handleCerrarModal}>
            <ModalBox onClick={(e) => e.stopPropagation()}>
              <ModalHeader>
                <p>Asignar — Cursos disponibles</p>
                <div style={{ padding: "0 15px" }}>
                  <FontAwesomeIcon
                    icon="times-circle"
                    className="hand-pointer"
                    style={{ color: "#fff", fontSize: "18px" }}
                    onClick={handleCerrarModal}
                  />
                </div>
              </ModalHeader>
              <ModalBody>
                {rowEnProceso && (
                  <div
                    style={{
                      background: "#f0f2f5",
                      borderRadius: "6px",
                      padding: "10px 14px",
                      marginBottom: "14px",
                      fontSize: "13px",
                      color: "#444",
                    }}
                  >
                    <strong>Profesor:</strong>{" "}
                    {rowEnProceso.EsVacante
                      ? "Vacante"
                      : rowEnProceso.NombreProfesor || "—"}
                    {rowEnProceso.Cargo && (
                      <span style={{ marginLeft: "12px", color: "#6b7280" }}>
                        · {rowEnProceso.Cargo}
                      </span>
                    )}
                  </div>
                )}
                <div>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#6b7280",
                      marginBottom: "6px",
                    }}
                  >
                    Curso:
                  </p>
                  <select
                    value={cursoSeleccionado ?? ""}
                    onChange={(e) => {
                      setCursoSeleccionado(e.target.value);
                    }}
                    style={{
                      width: "100%",
                      minWidth: "150px",
                      padding: "8px 12px",
                      border: "1px solid #d1d5db",
                      borderRadius: "6px",
                      fontSize: "13px",
                      color: "#333",
                      outline: "none",
                      cursor: "pointer",
                      backgroundColor: "#fafafa",
                      boxShadow: "none",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.borderColor = "#0367A6")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.borderColor = "#d1d5db")
                    }
                  >
                    <option value="" disabled style={{ color: "#9ca3af" }}>
                      -- Selecciona un curso --
                    </option>
                    {cursos.map((curso) => (
                      <option
                        key={curso.Descripcion}
                        value={curso.Descripcion}
                        style={{
                          fontSize: "13px",
                          color: "#333",
                          backgroundColor: "white",
                        }}
                      >
                        {curso.Descripcion}
                      </option>
                    ))}
                  </select>
                </div>
              </ModalBody>
              <ModalFooter>
                <button
                  onClick={handleAsignarCurso}
                  disabled={!cursoSeleccionado}
                  className="generic-button-buscador"
                  onMouseEnter={(e) => {
                    if (cursoSeleccionado)
                      e.currentTarget.style.background = "#0f02c4";
                  }}
                  onMouseLeave={(e) => {
                    if (cursoSeleccionado)
                      e.currentTarget.style.background = "#1403fa";
                  }}
                >
                  Guardar
                </button>
              </ModalFooter>
            </ModalBox>
          </ModalOverlay>
        )}

        <div className="generic-buscador-container">
          <div className="filtros-left-section">
            <input
              type="text"
              className="generic-input-criterio-busqueda"
              placeholder="Buscar por nombre o DNI"
              value={searchCriteria}
              onChange={(e) => setSearchCriteria(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") manageSearch();
              }}
            />
            <button
              onClick={manageSearch}
              type="button"
              className="generic-button-buscador"
            >
              Buscar
            </button>
            <a className="clean-filters" onClick={handleCleanSearch}>
              Limpiar búsqueda
            </a>
          </div>
        </div>

        <PageTable
          headers={HEADERS}
          paginator={paginator}
          setPaginator={setPaginator}
        >
          <tbody className="listar-tbody">
            {isLoading ? (
              <tr>
                <td colSpan={12} className="text-center py-4">
                  Cargando...
                </td>
              </tr>
            ) : formValues.Items.length === 0 ? (
              <tr>
                <td colSpan={12} className="text-center py-4">
                  No se encontraron resultados.
                </td>
              </tr>
            ) : (
              formValues.Items.map((row) => {
                const rowId = `${row.IdCuadroSede}-${row.IdAsignacion}-${row.IdEmpleado}`;
                return (
                  <tr key={rowId}>
                    <td className="text-center">
                      {row?.MensajeTooltip !== "" && (

                          <TooltipWrapper message={row.MensajeTooltip}>
                              <FontAwesomeIcon icon={faInfoCircle} size="xs" />
                          </TooltipWrapper>
                      )}
                    </td>
                    <td className="text-center">
                      {row.CodigoVacante ?? "—"}
                    </td>
                    {/* Tipo */}
                    <td>

                        {row.EsTrasladoProgramado && (!row.PuedeSeleccionarTipo || !row.TiposOptions?.length) ? (
                            <span style={{ color: "#6b7280", fontSize: "12px" }}>
                                Programado
                            </span>
                        ) : (
                            row?.PuedeSeleccionarTipo && !row?.Bloqueado &&
                            <Select
                                placeholder="Seleccionar"
                                options={row.TiposOptions}
                                value={
                                    ALL_TIPO_OPTIONS.find(
                                        (o) => o.value === tipoValues[rowId],
                                    ) || null
                                }
                                onChange={(res) =>
                                    handleTipoChange(rowId, res?.value, row)
                                }
                                menuPortalTarget={document.body} // ← ESTO
                                menuPosition="fixed" // ← Y ESTO
                                styles={{
                                    container: (base) => ({ ...base, minWidth: "150px" }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ← asegura que esté encima
                                    control: (base) => ({
                                        ...base,
                                        fontSize: "13px",
                                        borderColor: "#d1d5db",
                                        borderRadius: "6px",
                                        backgroundColor: "#fafafa",
                                        boxShadow: "none",
                                        "&:hover": { borderColor: "#0367A6" },
                                    }),
                                    option: (base, { isFocused }) => ({
                                        ...base,
                                        fontSize: "13px",
                                        backgroundColor: isFocused ? "#e8f0fe" : "white",
                                        color: "#333",
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: "13px",
                                        color: "#9ca3af",
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: "13px",
                                        color: "#333",
                                    }),
                                }}
                            />
                        )}

                    </td>
                    {/* Profesor */}
                    <td>
                      {row.NombreProfesor || "—"}
                      {row.EsTrasladoProgramado && (
                        <TrasladoBadge
                          title={`Traslado programado para el ${formatFecha(row.FechaEjecucionTraslado)}. La vacante destino se podrá asignar desde esa fecha.`}
                        >
                          Traslado programado
                        </TrasladoBadge>
                      )}
                    </td>
                    {/* Cargo */}
                    <td className="text-center">{row.Cargo || "—"}</td>
                    {/* Tipo Contrato */}
                    <td className="text-center">{row.TipoContrato || "—"}</td>
                    {/* Fecha Inicio */}
                    <td className="text-center">
                      {formatFecha(row.FechaIngresoEmpresa)}
                    </td>
                    {/* Grado Desarrollo */}
                    <td className="text-center">
                      {row.GradoDesarrollo || "—"}
                    </td>
                    {/* Desempeño */}
                    <td className="text-center">
                      {row.DesempenoGeneral != null ? (
                        <DesempenoValue value={row.DesempenoGeneral}>
                          {row.DesempenoGeneral}
                        </DesempenoValue>
                      ) : (
                        <span style={{ color: "#bbb" }}>—</span>
                      )}
                    </td>
                    {/* Etiqueta */}
                    <td className="text-center">
                      {row.Etiqueta ? (
                        (() => {
                          const s = ETIQUETA_COLORS[row.Etiqueta] || null;
                          return (
                            <EtiquetaBadge bg={s?.bg} color={s?.color}>
                              {row.Etiqueta}
                            </EtiquetaBadge>
                          );
                        })()
                      ) : (
                        <span style={{ color: "#bbb" }}>—</span>
                      )}
                    </td>
                    {/* Año de evaluación */}
                    <td className="text-center">
                      {row.AnioEvaluacion || "—"}
                    </td>
                    <td className="text-center">
                      <div
                        style={{
                          display: "flex",
                          gap: "6px",
                          justifyContent: "center",
                        }}
                      >

                        {!row.Bloqueado && row?.PuedeBloquearDesbloquear && (
                          <button
                            onClick={() => handleBloquear(row)}
                            title="Bloquear"
                            style={iconBtnStyle}
                          >
                            <FontAwesomeIcon icon={faLockOpen} />
                          </button>
                        )}
                        {row.Bloqueado && row?.PuedeBloquearDesbloquear &&(
                          <button
                            onClick={() => handleDesbloquear(row)}
                            title="Desbloquear"
                            style={iconBtnStyle}
                          >
                            <FontAwesomeIcon icon={faLock} />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </PageTable>
      </PageWrapper>
    </>
  );
}
